import { G_variablesAsync } from "../../../utils/globals/variables";
import WINDOW, { ENV_DEV } from "../../../utils/window";

/**
 * Check for global $$ variable. If it does not exists yet (the variable is defined lower in the DOM),
 * that add the element into the global variable and make another attempt later when the Main class
 * has finished initialization of all elements
 * @param {MainClassProps} main
 * @param {String} match
 */
const checkGlobalVariable = (main, match) => {
  if (!WINDOW.get("async-variables-attempt")) {
    G_variablesAsync.add(main.element);
  } else {
    G_variablesAsync.delete(main.element);

    if (ENV_DEV) {
      console.warn(
        `[TorusKit warn]: Cannot find a \`${match}\` variable definition`
      );
    }
  }
};

export default checkGlobalVariable;
